import { Layout } from '@consta/uikit/Layout'
import { Text } from '@consta/uikit/Text'
import type { FC } from 'react'

import css from './AddingFilesModal.css'
import type { AddingFilesModalHeaderPropsType as PropsType } from './types'

export const AddingFilesModalHeader: FC<PropsType> = ({ fileName }) => {
  return (
    <Layout className={css.containerHeader}>
      <Layout flex={1} direction="column">
        <Text as="h3" view="primary" weight="bold" size="xl" className={css.headerTitle}>
          Загрузка файла
        </Text>

        <Text as="span" view="secondary" size="s" weight="regular" className={css.headerTitleSub}>
          {fileName}
        </Text>
      </Layout>
    </Layout>
  )
}
